/**
 * Gets the appropriate thank you message based on feedback method, rating, and thumbs
 */
export const getThankYouMessage = (
  feedbackMethod: string,
  rating: number,
  thumbs: string | null,
  submissionDisplayMessage: Array<{ key: string; value: string }>
): string => {
  let message = "Thank you for your feedback!";

  if (feedbackMethod === "rating") {
    if (rating >= 1 && rating <= 2) {
      const msgObj = submissionDisplayMessage.find(
        (msg) => msg.key === "display1to2Star"
      );
      if (msgObj?.value) message = msgObj.value;
    } else if (rating === 3) {
      const msgObj = submissionDisplayMessage.find(
        (msg) => msg.key === "display3Star"
      );
      if (msgObj?.value) message = msgObj.value;
    } else if (rating >= 4 && rating <= 5) {
      const msgObj = submissionDisplayMessage.find(
        (msg) => msg.key === "display4to5Star"
      );
      if (msgObj?.value) message = msgObj.value;
    }
  } else if (feedbackMethod === "thumbs") {
    if (thumbs === "thumbsup") {
      const msgObj = submissionDisplayMessage.find(
        (msg) => msg.key === "display4to5Star"
      );
      if (msgObj?.value) message = msgObj.value;
    } else if (thumbs === "thumbsdown") {
      const msgObj = submissionDisplayMessage.find(
        (msg) => msg.key === "display1to2Star"
      );
      if (msgObj?.value) message = msgObj.value;
    }
  }

  return message;
};

/**
 * Updates session data in localStorage to mark feedback as submitted
 */
export const updateSessionData = (traceItemID: string): void => {
  const sessionData = JSON.parse(localStorage.getItem("sessionData") || "{}");
  if (!sessionData[traceItemID]) {
    sessionData[traceItemID] = {};
  }
  sessionData[traceItemID].feedbackSubmitted = true;
  localStorage.setItem("sessionData", JSON.stringify(sessionData));
};

export const validateEmail = (email: string): string => {
  if (!email) return '';
  return !/\S+@\S+\.\S+/.test(email) 
    ? 'Please enter a valid email address.'
    : '';
};

export const validateMobile = (mobile: string): string => {
  if (!mobile) return '';
  return !/^\d{10}$/.test(mobile)
    ? 'Please enter a valid 10-digit mobile number.'
    : '';
};

/**
 * Starts a countdown timer updating the state every second
 */
export const startCountdown = (
  setCountdown: React.Dispatch<React.SetStateAction<number>>
): void => {
  setCountdown(420);
  const timer = setInterval(() => {
    setCountdown((prev) => {
      if (prev <= 1) {
        clearInterval(timer);
        return 0;
      }
      return prev - 1;
    });
  }, 1000);
}; 